import type { Course } from '@mc/api'
import { useBucket } from '@mc/experiments-react'
import { useStaticData } from '@mc/static-data-react'
import { EXPERIMENT_FLAG, isExcludedSlug } from '../constants'

export const useIsHeroOnly = () => {
  const { course } = useStaticData<{ course: Course }>()
  const bucket = useBucket(EXPERIMENT_FLAG)

  return !isExcludedSlug(course?.slug) && bucket === 'variant_1'
}
